import React from 'react';
import { Button, HStack, IconButton, Text, useTheme } from 'native-base';
import { IS_SMALLER_DEVICE } from '../../../Constants';
import { useDomParser } from '../../../../components/hooks/useDomParser';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faImage } from '@fortawesome/pro-regular-svg-icons';
const PostModalFooter = ({
  topic,
  id,
  key,
  selectedPostCategoryId,
  data,
  handlePost,
  setShowModal,
  isValid,
  onCloseHandler,
  handleImage
}) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const {
    getParser,
    submitAtMentions
  } = useDomParser();
  const isNewOrEditReply = id === 'newReply' || id === 'edit' && !topic;
  const substituteBeforePost = async data => {
    // parse/normalize markup
    let sourceHTML = data.raw;
    const parser = getParser();
    if (parser) {
      sourceHTML = submitAtMentions(parser, sourceHTML);
    }
    data.raw = sourceHTML;
    handlePost(data);
    onCloseHandler && onCloseHandler();
  };

  // attach category to new topic data
  if (id === 'newTopic' || key === 'newTopic') {
    data.category = selectedPostCategoryId;
  }
  return /*#__PURE__*/React.createElement(Button.Group, isNewOrEditReply ? {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingX: '2',
    paddingBottom: '2',
    marginTop: '5rem'
  } : {
    alignSelf: 'flex-end',
    position: 'relative',
    bottom: IS_SMALLER_DEVICE ? '2vh' : '1vh',
    right: IS_SMALLER_DEVICE ? '2vw' : '1vw'
  }, isNewOrEditReply && /*#__PURE__*/React.createElement(Button, {
    onPress: handleImage,
    variant: "outline",
    _text: {
      color: 'ghost'
    },
    style: {
      padding: '1'
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(IconButton, {
    style: {
      padding: 0,
      marginRight: 4
    },
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faImage
    })
  }), /*#__PURE__*/React.createElement(Text, null, "Add Image"))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      gap: 4
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    colorScheme: "blueGray",
    onPress: () => setShowModal && setShowModal(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onPress: async () => {
      if (!isValid) {
        throw new Error('Invalid data. Aborting the request');
      } else {
        await substituteBeforePost(data);
        setShowModal && setShowModal(false);
      }
    },
    isDisabled: !isValid,
    style: isNewOrEditReply ? {
      backgroundColor: colors.purple.primary
    } : undefined
  }, id === 'edit' || key === 'edit' ? 'Update' : isNewOrEditReply ? 'Reply' : 'Post')));
};
export default PostModalFooter;
//# sourceMappingURL=PostModalFooter.js.map